import { useAppContext } from '../../Services/AppContext';
import { useEffect, useRef, useState } from 'react';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import { gql } from '@apollo/client';
import { PROFILE_NAME_FRAGMENT, AVATAR_FRAGMENT } from '../UserInfo/UserData';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import SearchWorkplaceDoctorResult from './SearchWorkplaceDoctorResult';
import SearchWorkplaceDoctorNoResults from './SearchWorkplaceDoctorNoResults';
import SearchMD from '../SearchMD/SearchMD';
import { WorkplaceMember } from '../../graphql/graphql';

export default function SearchWorkplaceDoctor({
	handleClick = null,
	gqlParams = {},
	hideEmptySearch = false,
	changeButton = null,
	placeholder = null,
	changeText = null,
}) {
	const { translation } = useAppContext();
	const [items, setItems] = useState<WorkplaceMember[] | null>(null);
	const [fulltext, setFulltext] = useState('');
	const inputRef = useRef(null);

	const searchQuery = gql`
		${PROFILE_NAME_FRAGMENT}
		${AVATAR_FRAGMENT}
		query Doctors($fulltext: String!, $workplaceId: UUID) {
			workplaceDoctors(fulltext: $fulltext, workplaceId: $workplaceId) {
				data {
					id
					workplace {
						id
						name
						caseDoctorDescription
					}
					user {
						id
						...avatar
						profile {
							...userName
						}
					}
				}
			}
		}
	`;

	const handleSearch = text => {
		setFulltext(text);
	};

	const handleClickInside = item => {
		setItems(null);
		setFulltext('');
		inputRef.current.value = item.user.profile.fullName;
		handleClick(item);
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, []);

	const handleClickOutside = event => {
		const domNode = ReactDOM.findDOMNode(inputRef.current).parentNode
			.parentNode;
		if (!domNode || !domNode.contains(event.target)) {
			setItems(null);
		}
	};

	const variables = { fulltext, ...gqlParams };

	// @ts-ignore
	useEffectAsync(async () => {
		if (!hideEmptySearch || fulltext.length > 2) {
			const result = await apiClient.graphql({
				query: searchQuery,
				variables: variables,
				fetchPolicy: 'network-only',
			});
			setItems(result?.data?.workplaceDoctors?.data || []);
		} else {
			setItems(null);
		}
	}, [fulltext]);

	const itemsContent = items?.length ? (
		items.map(item => (
			<SearchWorkplaceDoctorResult
				key={item.user.id}
				workplaceMember={item}
				handleClick={handleClickInside}
			/>
		))
	) : (
		<SearchWorkplaceDoctorNoResults />
	);

	return (
		<SearchMD
			ref={inputRef}
			resultContent={items !== null ? itemsContent : null}
			handleSearch={handleSearch}
			placeholder={
				placeholder || translation['base.startTypingSurnameOfAttendingDoctor']
			}
			changeButton={changeButton}
			changeText={changeText}
		/>
	);
}
